export default {
  "content": "<path fill=\"#FFC700\" d=\"M0 0h48v48H0z\"/><path fill=\"#007F41\" d=\"M0 0h48v48H0z\"/><path fill=\"#fff\" d=\"M25.628 12.83c-3.476 1.825-5.359 5.59-3.47 10.297 1.769 4.354 5.835 9.416 5.895 9.476l-15.976-9.181c-.47-.235-1.005-.06-1.18.414-1.118 3.47 1.18 8.413 5.956 11.12.944.53 1.942.944 2.827 1.238 4.716 1.41 9.726-.943 11.669-5.236l5.48-12.124c.71-1.591.763-3.47 0-4.942-1.89-3.47-6.659-2.527-9.258-1.825-.65.174-1.3.414-1.943.762z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "48",
    "height": "48",
    "fill": "none",
    "viewBox": "0 0 48 48"
  }
};